import React from 'react';

/**
 * Carte de témoignage pour l'onboarding
 */
export default function TestimonialCard({ testimonial }) {
  const { name, city, improvement, subject, before, after, duration, quote, rating } = testimonial;

  return (
    <div className="bg-white rounded-3xl p-5 shadow-xl border-4 border-yellow-200">
      <div className="flex items-start gap-3">
        {/* Avatar */}
        <div className="w-16 h-16 rounded-xl bg-gray-200 overflow-hidden flex-shrink-0">
          <img
            src={testimonial.image || '/placeholder.svg'}
            alt={name}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.src = '/placeholder.svg';
            }}
          />
        </div>

        {/* Info */}
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-semibold text-gray-800">{name}</p>
              <p className="text-gray-500 text-sm flex items-center gap-1">
                <span className="text-pink-500">📍</span> {city}
              </p>
            </div>
            
            {/* Badge amélioration */}
            <div className="bg-green-500 text-white text-sm font-bold px-3 py-1 rounded-full">
              {improvement}
            </div>
          </div>

          {/* Stats */}
          <div className="mt-3 bg-gradient-to-r from-emerald-50 to-teal-50 rounded-xl border-2 border-emerald-200 p-2 flex items-center justify-between text-sm">
            <div>
              <p className="text-gray-500 text-xs">Transformation</p>
              <p className="text-sm font-bold text-emerald-700">
                De {before} à {after} en {subject}
              </p>
            </div>
            <div className="text-right">
              <p className="text-gray-500 text-xs">Durée</p>
              <p className="font-semibold text-gray-800 text-xs">En {duration}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Rating */}
      <div className="flex items-center gap-1 mt-3">
        {[...Array(rating)].map((_, i) => (
          <span key={i} className="text-yellow-400 text-md">⭐</span>
        ))}
      </div>

      {/* Quote */}
      <p className="mt-2 text-gray-700 font-medium text-sm italic">"{quote}"</p>
    </div>
  );
}
